<template>
  <b-card class="rounded-xl">
    <modal :show.sync="editModal" header-classes="bg-primary p-3">
      <h6 slot="header" class="modal-title text-white font-semibold pt-1">
        EDIT IMAGE ORDER
      </h6>
      <EditTagsDetail />
      <template slot="footer">
        <base-button type="primary">SAVE CHANGES</base-button>
        <base-button type="secondary" class="ml-auto" @click="editModal = false"
          >CLOSE</base-button
        >
      </template>
    </modal>
    <AddTagsSidebar
      :isSidebarActive="openAddBannerSidebar"
      @closeSidebar="toggleAddBannerSidebar"
    />
    <div class="flex  justify-between  items-center">
      <div>
        <h2 class="text-2xl font-semibold">
          Custom Duty
        </h2>
      </div>
      <!-- <base-button outline type="success" class="flex" @click="addBanner">
        <feather-icon icon="PlusIcon" class="mr-1"></feather-icon>Add
        Transactions
      </base-button> -->
    </div>
    <b-input-group class="mt-12">
      <b-form-input
        class="border-none shadow-lg"
        type="text"
        min="0.00"
        placeholder="Enter Search...."
      ></b-form-input>

      <b-input-group-append>
        <b-button
          variant="white"
          class="flex items-center shadow-lg"
          aria-label="search"
        >
          <feather-icon
            class=" cursor-pointer  mr-2"
            icon="SearchIcon"
            svgClasses="w-4 h-4"
          ></feather-icon>
        </b-button>
      </b-input-group-append>
    </b-input-group>
    <el-table
      class="table-responsive table-flush mt-6"
      header-row-class-name="thead-light table-th-color"
      :data="TagsData"
    >
      <el-table-column
        label="Order ID"
        prop="orderID"
        min-width="120px"
        sortable
      >
        <template v-slot="{ row }">
          <span class=" text-black font-medium">{{ row.orderID }}</span>
        </template>
      </el-table-column>
      <el-table-column label="Amount" min-width="120px" prop="amount" sortable>
        <template v-slot="{ row }">
          <span class=" text-black font-medium">{{ row.amount }}</span>
        </template>
      </el-table-column>
      <el-table-column
        label="Custom Duty Charges"
        min-width="130px"
        prop="customdutycharges"
        sortable
      >
        <template v-slot="{ row }">
          <span class=" text-black font-medium">{{
            row.customdutycharges
          }}</span>
        </template>
      </el-table-column>

      <el-table-column label="Status" min-width="150px" prop="status" sortable>
        <template v-slot="{ row }">
          <span class=" text-black font-medium">{{ row.status }}</span>
        </template>
      </el-table-column>

      <el-table-column label="Action" min-width="150px">
        <template>
          <div class="flex items-center">
            <div class="flex items-center mr-4 cursor-pointer">
              <feather-icon
                @click="editModal = true"
                block
                icon="CreditCardIcon"
                svgClasses="w-5"
                data-toggle="tooltip"
                data-placement="top"
                title="Pay"
              ></feather-icon>
            </div>
            <!-- <div class="flex items-center cursor-pointer">
              <feather-icon
                icon="EyeIcon"
                svgClasses="w-5"
                @click="
                  tableModal = true;
                  selectedName = row.vendorname;
                "
                block
              ></feather-icon>
            </div> -->
          </div>
        </template>
      </el-table-column>
    </el-table>

    <b-card-footer class="py-4 d-flex justify-content-end">
      <base-pagination
        v-model="currentPage"
        :per-page="10"
        :total="50"
      ></base-pagination>
    </b-card-footer>
  </b-card>
</template>
<script>
import "../../scss/Index.scss";
import TagsData from "./components/TagsData";
import EditTagsDetail from "./components/EditTagsDetail";
import AddTagsSidebar from "./components/AddTagsSidebar";
import {
  Table,
  TableColumn,
  DropdownMenu,
  DropdownItem,
  Dropdown
} from "element-ui";
export default {
  name: "light-table",
  components: {
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [Dropdown.name]: Dropdown,
    [DropdownItem.name]: DropdownItem,
    [DropdownMenu.name]: DropdownMenu,
    EditTagsDetail,
    AddTagsSidebar
  },
  data() {
    return {
      TagsData,
      currentPage: 1,
      editModal: false,
      tableModal: false,
      openAddBannerSidebar: false,
      selectedName: ""
    };
  },
  methods: {
    addBanner() {
      this.toggleAddBannerSidebar(true);
    },
    toggleAddBannerSidebar(val = false) {
      this.openAddBannerSidebar = val;
    }
  }
};
</script>
